"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalloutContent = void 0;
var Utilities_1 = require("../../Utilities");
var CalloutContent_base_1 = require("./CalloutContent.base");
var CalloutContent_styles_1 = require("./CalloutContent.styles");
exports.CalloutContent = Utilities_1.styled(CalloutContent_base_1.CalloutContentBase, CalloutContent_styles_1.getStyles, undefined, {
    scope: 'CalloutContent',
});
//# sourceMappingURL=CalloutContent.js.map